import { useT } from '@dia/i18n';
import { loadShell } from '@dia/content';
import { LangToggle, Screen } from '@dia/ui';
import { HOSTS_WHATSAPP } from '../env';
import { isPlaceholderNumber, normalizeWhatsAppNumber } from './logic/whatsapp';
import { BackLink } from './parts/BackLink';
import { DocArticle } from './parts/Prose';

const content = loadShell('guest');

/**
 * Safety comes first in an emergency, so it is public, bundled, and puts a
 * working tap target at the top. There is no 911 to fall back on here: Panama's
 * emergency line does not reach this island. The crew are the whole system —
 * they have the boat and know the way to the hospital — so their number is the
 * only tap target, once a real one is set. Until then this shows a plain
 * notice rather than a dead link. Everything else is a page in
 * content/guest/safety/, where the missing facts are visible placeholders
 * until they are confirmed.
 */
export function Safety() {
  const { t } = useT();
  const pages = content.section('safety');

  const crewDigits = normalizeWhatsAppNumber(HOSTS_WHATSAPP);
  const crewReady = Boolean(crewDigits && !isPlaceholderNumber(crewDigits));

  return (
    <Screen title={t('guest.safety.title')} lede={t('guest.safety.lede')} actions={<LangToggle />}>
      <BackLink />
      <div className="flex flex-col gap-8 mt-2">
        {crewReady ? (
          <a
            href={`tel:+${crewDigits}`}
            className="flex flex-col gap-1 rounded border border-accent px-4 py-4 min-h-tap text-accent focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent"
          >
            <span className="font-display text-[1.4em]">{t('guest.safety.crew_title')}</span>
            <span className="underline underline-offset-4">{t('guest.safety.crew_hint')}</span>
          </a>
        ) : (
          <p className="rounded border border-line px-4 py-4 text-inkMuted">{t('guest.safety.crew_pending')}</p>
        )}

        {pages.map((doc) => (
          <DocArticle key={doc.path} doc={doc} className="border-t border-line pt-6" />
        ))}
      </div>
    </Screen>
  );
}
